export default () => ({
  streamGroups: [],
  currentMentionStreamGroupIndex: -1,
  currentSocialStreamGroupIndex: -1,
});
